export const API_KEY = "963c2858-dff8-4710-99fb-387455ce20d3";
export const API_KEY_CAT = "8791c4b6-dbf6-445b-bf7a-dcf3779d142b";
export const USER_ID = "pablodesign-22062022";
